module.exports = __webpack_public_path__ + "static/media/inches.482d3b0a.svg";